<mat-form-field class="mat-input--flush" appearance="outline">
  <mat-label>{{config.searchName}}</mat-label>
  <input #search matInput [placeholder]="config.placeholder"/>
  <mat-icon matPrefix>{{config.matIcon}}</mat-icon>
</mat-form-field>
